import { IApiResponse } from '../../../../../types'

export interface IMerchantOperator {
  id: number
  uuid: string
  enabled: boolean
  roles: string[]
  createdAt: string
  updatedAt: string
}

export interface IMerchantPlatform {
  id: number
  uuid: string
  enabled: boolean
  callbackUrl: string
  roles: string[]
  createdAt: string
  updatedAt: string
}

// Таймаут платёжной страницы мерчанта: пустое значение — общий порог бэкенда. Верхняя граница
// равна полному времени жизни matching-депозита, дольше тикет всё равно гасится.
export const PAYMENT_PAGE_TIMEOUT_DEFAULT_MINUTES = 20
export const PAYMENT_PAGE_TIMEOUT_MAX_MINUTES = 35

// Порог автоостановки matching-выплат мерчанта: сколько разных клиентов подряд не смогли оплатить.
// Пустое значение — порог платформы.
export const MATCHING_AUTO_HALT_DEFAULT_CLIENTS = 8
export const MATCHING_AUTO_HALT_MIN_CLIENTS = 2
export const MATCHING_AUTO_HALT_MAX_CLIENTS = 50

export interface IMerchant {
  id: number
  token: string
  title: string
  enabled: boolean
  allowAnonymousPayments: boolean
  variantFallbackPgEnabled?: boolean
  variantFallbackH2hEnabled?: boolean
  depositPrecheckEnabled?: boolean
  depositSupersedeEnabled?: boolean
  paymentPageTimeoutMinutes?: number | null
  matchingAutoHaltClients?: number | null
  /** Present only for the roles that may edit it. */
  apiIpAllowlist?: string[]
  apiIpAllowlistEnabled?: boolean
  userPageHost: string | null
  createdAt: string
  updatedAt: string
  platform: IMerchantPlatform
  operators: IMerchantOperator[]
  // merchants_managers — вторая связь мерчанта с сотрудниками. Бэкенд отдаёт её только
  // роли с ROLE_EMPLOYEE (admin/manager), менеджеру мерчантов поле не приходит.
  merchantManagers?: IMerchantOperator[]
}

export type IMerchantDetailRes = IApiResponse<{ merchant: IMerchant }>

export type MerchantCurrency = 'USDT' | 'RUB'

export interface CurrencyOption {
  value: MerchantCurrency
  label: string
}

export type IMerchantActiveCurrencyRes = IApiResponse<{ data: { merchantId: number; currency: MerchantCurrency } }>

export interface IMerchantBalancePolicy {
  merchantId: number
  enforceBalance: boolean
  overdraftLimit: string
}

export type IMerchantBalancePolicyRes = IApiResponse<{ data: IMerchantBalancePolicy }>
